(function () {
  var overlay = document.getElementById("overlay");
  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.hidden = false;
    el.classList.add("is-open");
    if (overlay) {
      overlay.hidden = false;
      overlay.classList.add("is-open");
    }
  }
  function closeDrawers() {
    document.querySelectorAll(".drawer").forEach(function (d) {
      d.hidden = true;
      d.classList.remove("is-open");
    });
    if (overlay) {
      overlay.hidden = true;
      overlay.classList.remove("is-open");
    }
  }
  var menuBtn = document.getElementById("btn-menu");
  var searchBtn = document.getElementById("btn-search");
  if (menuBtn) menuBtn.addEventListener("click", function () { openDrawer("drawer-nav"); });
  if (searchBtn) searchBtn.addEventListener("click", function () { openDrawer("drawer-search"); });
  if (overlay) overlay.addEventListener("click", closeDrawers);
  document.querySelectorAll("[data-close]").forEach(function (btn) {
    btn.addEventListener("click", closeDrawers);
  });
  document.addEventListener("mouseover", function (e) {
    var card = e.target.closest(".card");
    if (card) card.classList.add("is-hover");
  });
  document.addEventListener("mouseout", function (e) {
    var card = e.target.closest(".card");
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    card.classList.remove("is-hover");
  });

  var wishKey = "dt-wish";
  function readWish() {
    try { return JSON.parse(localStorage.getItem(wishKey) || "[]"); } catch (e) { return []; }
  }
  function writeWish(ids) {
    localStorage.setItem(wishKey, JSON.stringify(ids));
  }
  document.querySelectorAll("[data-wishlist]").forEach(function (btn) {
    var id = btn.getAttribute("data-wishlist");
    if (readWish().indexOf(id) !== -1) btn.classList.add("is-on");
    btn.addEventListener("click", function () {
      var ids = readWish();
      var i = ids.indexOf(id);
      if (i === -1) ids.push(id);
      else ids.splice(i, 1);
      writeWish(ids);
      btn.classList.toggle("is-on", i === -1);
    });
  });

  var grid = document.getElementById("wishlist-grid");
  if (grid && window.DT_PRODUCTS) {
    var empty = document.getElementById("wishlist-empty");
    var html = "";
    readWish().forEach(function (id) {
      var p = window.DT_PRODUCTS[id];
      if (!p) return;
      html += '<article class="card"><div class="card-media"><a href="' + p.url + '"><img src="' + p.image + '" alt=""></a></div><div class="card-info"><div class="card-col">' + p.vendor + '</div><a class="card-title" href="' + p.url + '">' + p.title + '</a><div class="card-price">' + p.price + "</div></div></article>";
    });
    if (html) {
      grid.innerHTML = html;
      if (empty) empty.hidden = true;
    }
  }

  document.querySelectorAll(".thumbs img").forEach(function (img) {
    var mainImg = document.getElementById("main-img") || document.querySelector(".gallery-main img");
    function show() {
      if (!mainImg) return;
      mainImg.src = img.getAttribute("data-full") || img.src;
      document.querySelectorAll(".thumbs img").forEach(function (x) {
        x.classList.toggle("is-on", x === img);
      });
    }
    img.addEventListener("mouseenter", show);
    img.addEventListener("click", show);
  });

  document.querySelectorAll(".zoomable").forEach(function (img) {
    img.addEventListener("click", function () {
      var layer = document.createElement("div");
      layer.className = "zoom is-open";
      layer.innerHTML = "<img src=\"" + img.src + "\" alt=\"\">";
      layer.addEventListener("click", function () { layer.remove(); });
      document.body.appendChild(layer);
    });
  });

  var header = document.getElementById("site-header");
  function syncHeader() {
    if (!header) return;
    var hasHero = Boolean(document.querySelector("[data-hero]"));
    header.classList.toggle("is-over-hero", hasHero && window.scrollY < 48);
  }
  syncHeader();
  window.addEventListener("scroll", syncHeader, { passive: true });

  var form = document.querySelector("[data-product-form]");
  if (form) {
    var select = document.getElementById("VariantId");
    var price = form.querySelector("[data-price]");
    var addBtn = form.querySelector('[name="add"]');
    function selectedValues() {
      return Array.prototype.map.call(form.querySelectorAll(".opt-row"), function (row) {
        var on = row.querySelector(".size-btn.is-on");
        return on ? on.getAttribute("data-value") : "";
      }).join("|");
    }
    function syncVariant() {
      if (!select) return;
      var key = selectedValues();
      var match = Array.prototype.find.call(select.options, function (opt) {
        return opt.getAttribute("data-options") === key;
      });
      if (match) {
        select.value = match.value;
        if (price) price.textContent = match.getAttribute("data-price");
        if (addBtn) addBtn.disabled = match.getAttribute("data-available") !== "true";
      }
    }
    form.querySelectorAll(".opt-row").forEach(function (row) {
      row.querySelectorAll(".size-btn").forEach(function (btn) {
        btn.addEventListener("click", function () {
          row.querySelectorAll(".size-btn").forEach(function (b) { b.classList.remove("is-on"); });
          btn.classList.add("is-on");
          syncVariant();
        });
      });
    });
  }
})();
